import styled from '@emotion/styled';
import { Component } from 'react';

// Assets
import { ASSET_URLS } from '../utils';

const Header = styled.div`
  align-items: center;
  display: flex;
  padding: 1em;
  position: relative;
  width: 100%;
`;

const OCLogo = styled.span`
  background-image: url(${ASSET_URLS.ocLogoUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 4.5em;
  margin-right: 0.75em;
  position: relative;
  width: 4.5em;

  @media (max-width: 1050px) {
    height: 4em;
    width: 4em;
  }

  @media (max-width: 768px) {
    height: 3.5em;
    width: 3.5em;
  }

  width: 46px;
  height: 40px;
`;

const Title = styled.span`
  color: #56595d;
  display: inline-block;
  line-height: 120%;
  font-family: 'OCRoboto';
  font-weight: 450;
  position: relative;
  font-size: calc(11px + (16 - 11) * ((100vw - 320px) / (1228 - 320)));
`;

const Reg = styled.span`
  &:after {
    content: '\\ae';
    display: inline-block;
    font-size: 0.7rem;
    position: relative;
    top: -0.5em;
  }
`;

const WideScreen = styled.div`
  display: none;

  @media (min-width: 870px) {
    display: block;
  }
`;

const NarrowScreen = styled.div`
  display: none;

  @media (max-width: 869.9px) {
    display: block;
  }
`;

export default class WarrantyHeader extends Component {
  render() {
    return (
      <div>
        <WideScreen>
          <Header
            style={{
              height: '68px',
              borderRadius: '3px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
              backgroundColor: '#f4f4f4',
              borderBottom: '1px solid rgb(202, 202, 202)',
            }}
          >
            <OCLogo className={this.props.OCLogo} />
            <Title>All Lifetime Warranties - Single Family Homes</Title>
          </Header>
        </WideScreen>

        <NarrowScreen>
          <Header
            style={{
              height: '68px',
              borderRadius: '3px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
              backgroundColor: '#ffffff',
              borderBottom: '1px solid rgb(202, 202, 202)',
            }}
          >
            <OCLogo className={this.props.OCLogo} />
            <Title>All Lifetime Warranties - Single Family Homes</Title>
          </Header>
        </NarrowScreen>
      </div>
    );
  }
}
